export const getUsers = ({ userReducer: { users = [] } = {} }) =>
  users;
export const getUsersFilter = ({ userReducer: { filter = {} } = {} }) =>
  filter;
export const getUsersCount = ({ userReducer: { count = 0 } = {} }) =>
  count;
